import { useEffect } from 'react'
interface IProps {
  ids: string[]
  setValue: any
  isFetched?: boolean
  trigger?: any
}

export const usePhone = (props: IProps) => {
  const { setValue, ids, isFetched, trigger } = props
  const isModifierKey = (event: KeyboardEvent) => {
    const key = event.keyCode

    return (
      event.shiftKey === true ||
      key === 35 ||
      key === 36 || // Allow Shift, Home, End
      key === 8 ||
      key === 9 ||
      key === 13 ||
      key === 46 || // Allow Backspace, Tab, Enter, Delete
      (key > 36 && key < 41) || // Allow left, up, right, down
      ((event.ctrlKey === true || event.metaKey === true) &&
        (key === 65 || key === 67 || key === 86 || key === 88 || key === 90))
    )
  }

  const formatToPhone = (event: KeyboardEvent) => {
    if (isModifierKey(event)) {
      return
    }

    if (event.target instanceof HTMLInputElement) {
      const input = event?.target?.value.replace(/\D/g, '').substring(0, 10)
      const zip = input.substring(0, 3)
      const middle = input.substring(3, 6)
      const last = input.substring(6, 10)

      if (input.length > 6) {
        setValue(event?.target?.name, `${zip} ${middle} ${last}`)
      } else if (input.length > 3) {
        setValue(event?.target?.name, `${zip} ${middle}`)
      } else if (input.length > 0) {
        setValue(event?.target?.name, `${zip}`)
      }
      trigger && trigger(event?.target?.name)
    }
  }

  useEffect(() => {
    ids.forEach((id) => {
      const element = document.getElementById(id)
      element?.addEventListener('keyup', formatToPhone)
    })
  }, [isFetched])
}
